import axios from "axios";
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const votePermissionCheck = async (resourceId = null, apiToken = null) => {
    if (!apiToken) {
        console.log("no apiToken");
        return null;
    }
    if (!resourceId) {
        console.log("no resourceId");
        return null;
    }
    console.log("CALLING SERVER with votepermissioncheck")
    return await axios({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'votepermissioncheck',
            'apiToken': apiToken,
            'aboutformstateid': resourceId
        },
    }).then((resp) => {
        if (resp?.data) {
            return resp.data;
        }
        console.log("NO RESPONSE from votepermissioncheck call");
    }).catch((error) => { console.log(error); });
};

export default votePermissionCheck;